export const isLoggedSelector = (state) => state.baseAuthReducer.isLogged;
export const uidSelector = (state) => state.baseAuthReducer.uid;
export const emailSelector = (state) => state.baseAuthReducer.email;
export const permissionsSelector = (state) => state.baseAuthReducer.permissions;
//
export const registerSelector = (state) => state.baseAuthReducer.register;
export const registerStepSelector = (state) => state.baseAuthReducer.step;
export const registerLastMailSelector = (state) =>
  state.baseAuthReducer.lastMail;
